/**
 * AG Grid License and Global Configuration
 *
 * This module registers AG Grid enterprise modules and sets global options.
 * The theme is imported from the centralized mesf-theme module.
 */

import { ModuleRegistry, provideGlobalGridOptions } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";
import { mesfTheme } from "./ag-grid/mesf-theme";

const licenseKey = import.meta.env.VITE_AG_GRID_LICENSE;

LicenseManager.setLicenseKey(licenseKey);

ModuleRegistry.registerModules([AllEnterpriseModule]);

provideGlobalGridOptions({
	theme: mesfTheme,
});
